import {Injectable} from '@angular/core';
import {ApiService, EnvironmentModel, PaginatedRequest} from '@cas-hub/acabim-common-client';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MaintenanceTypeWithCategory, UpdateAccountModel, LTMSType} from '../_models/ltms.model';
import {map} from 'rxjs/operators';
import {LTMSProjectItems} from "../pages/bim/building-management/building-financial-management/building-financial-management.component";
import {BudgetModel} from '@cas-hub/acabim-financial-client';

@Injectable({
    providedIn: 'root'
})
export class LtmsService extends ApiService {
    constructor(
        protected client: HttpClient,
        protected environment: EnvironmentModel
    ) {
        super(client, environment);
    }

    protected controller = 'financial';

    public getTypes(): Observable<MaintenanceTypeWithCategory[]> {
        return this.client.get(this.url('ltms/type'), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => (data as any).data as MaintenanceTypeWithCategory[]));
    }

    public getTypeDetails(typeId: string): Observable<any> {
        return this.client.get(this.url('organisation/maintenance-type/' + typeId), {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public addType(type: LTMSType): Observable<any> {
        return this.client.post(this.url('organisation/maintenance-type'), type, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public editType(id: string, type: LTMSType): Observable<any> {
        return this.client.post(this.url('organisation/maintenance-type/' + id), type, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public getCategories(): Observable<any> {
        return this.client.get(this.url('utilities/maintenance-type-categories'), {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public getAccounts(): Observable<any> {
        return this.client.get(this.url('account/expense'), {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public updateAccount(type: UpdateAccountModel, typeId: string): Observable<any> {
        return this.client.post(this.url('organisation/maintenance-type/' + typeId), type, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public addAccount(type: UpdateAccountModel): Observable<any> {
        return this.client.post(this.url('organisation/maintenance-type'), type, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public getItemsForProject(projectId: string, pagination?: PaginatedRequest): Observable<LTMSProjectItems[]> {
        let params = new HttpParams();
        if (pagination) {
            params = pagination.getParams(params);
        }
        return this.client.get(this.url('ltms/project/' + projectId), {
            params,
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => (data as any).data as LTMSProjectItems[]));
    }

    public updatingOpeningBalance(projectId: string, itemId: string, year: number, amount: number): Observable<any> {
        const body = {year, amount};
        return this.client.post(this.url('ltms/project/' + projectId + '/' + itemId + '/balance'), body, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }


    public getBudgetForItem(itemId: string): Observable<BudgetModel[]> {
        return this.client.get(this.url('ltms/item/' + itemId + '/budget'), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => (data as any).data as BudgetModel[]));
    }

    public getExpenditureForItem(itemId: string): Observable<BudgetModel[]> {
        return this.client.get(this.url('ltms/item/' + itemId + '/actual'), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(data => (data as any).data as BudgetModel[]));
    }

    public addBudgetsForItem(itemId: string, budget: { year: number; amount: number; cbi_class_id?: number;}): Observable<any> {
        return this.client.post(this.url('ltms/item/' + itemId + '/budget'), budget, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public addExpenditureForItem(itemId: string, budget: { year: number; amount: number; cbi_class_id?: number; }): Observable<any> {
        return this.client.post(this.url('ltms/item/' + itemId + '/actual'), budget, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public updateBudgetsForItem(itemId: string, budget: { year: number; amount: number; cbi_class_id?: number; }): Observable<any> {
        return this.client.post(this.url('ltms/item/' + itemId + '/budget/' + budget.year), budget, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public updateExpenditureForItem(itemId: string, expenditure: { year: number; amount: number; cbi_class_id?: number; }): Observable<any> {
        return this.client.post(this.url('ltms/item/' + itemId + '/actual/' + expenditure.year), expenditure, {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }


    public removeBudgetsForItem(itemId: string, year: number): Observable<any> {
        return this.client.delete(this.url('ltms/item/' + itemId + '/budget/' + year), {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }

    public removeExpenditureForItem(itemId: string, year: number): Observable<any> {
        return this.client.delete(this.url('ltms/item/' + itemId + '/actual/' + year), {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }
}
